export const toLowerCaseExceptFirstLetter = (text) =>
    text.replaceAll(/\S*/g, word =>
        `${word.slice(0, 1)}${word.slice(1).toLowerCase()}`
    );

export const upperCaseFirstLetter = (text) => `${text.slice(0, 1).toUpperCase()}${text.slice(1)}`

export const isEpmty = (text) => !text || text.length === 0 || text === null || (typeof text === 'string' ? text.trim() === "" : text === "")